import { useEffect, useState } from "react";
import { getLabList } from "../../api/api";
import { useAppDispatch, useAppSelector } from "../../redux/store/storehooks";
import { UpdateLabList } from "../../redux/reducers/lablistSlice";
import { errorNotify } from "../../services/toast.notification";
import { Col, Row } from "antd";
import CustomSelect from "../../components/_common/CustomSelect";
import VoipManagement from './voipManagment';
import Spinner from "../../components/_common/Spinner";

const VoipManagement1 = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [selectedLab, setSelectedLab] = useState(0);
    const [labList, setLabList] = useState([]);

    const dispatch = useAppDispatch();

    useEffect(() => {
        _getLabList();
    }, [])

    const _getLabList = () => {

        getLabList()
            .then((result: any) => {
                debugger;

                dispatch(UpdateLabList({ labList: result.data.data }))
                var list:any = [];
                list.push({prk_AndriodLab_AutoID:0 , str_LabPersianName:'همه'});

                result.data.data.map((item:any) =>{
                    list.push({prk_AndriodLab_AutoID:item.prk_AndriodLab_AutoID , str_LabPersianName:item.str_LabPersianName})
                })

                setLabList(list);
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })

    }

    const labChange = (event: any) => {
        setSelectedLab(event.target.value);
    }

    return (
    
    <>
{!isLoading && (
    <>
        <Row style={{justifyContent:'center'}}>
            <Col lg={12} md={12} sm={12} xs={12}>
                <CustomSelect
                    name="labId"
                    placeholder="آزمایشگاه"
                    itemList={labList}
                    value={selectedLab.toString()}
                    onChange={labChange}
                    valueObjectField={"prk_AndriodLab_AutoID"}
                    displayObjectField={"str_LabPersianName"}
                />
            </Col>
        </Row>

        <VoipManagement permission={true} labId={selectedLab} /> 
        </>
)}
{
            isLoading === true && (
                <Spinner />
            )
        }
    </>)
}

export default VoipManagement1;